import { Component, Input, OnInit } from '@angular/core';
import { Order, OrderItem, OrderType } from 'src/app/api/contracts/order';
import { OrderItemStatus } from 'src/app/types/order';

@Component({
  selector: 'app-order-list-item-status',
  templateUrl: './order-list-item-status.component.html',
  styleUrls: ['./order-list-item-status.component.scss'],
})
export class OrderListItemStatusComponent  implements OnInit {

  @Input() order!: Order;
  @Input() orderItem!: OrderItem;

  public readonly orderStatuses = OrderItemStatus;
  public readonly orderTypes = OrderType;

  constructor() { }

  ngOnInit() {
    return;
  }

}
